import { ScrollEventAdapter } from "hoksource";
import * as React from 'react';
export function useOnScrollBottom(targetElement, callback) {
    var scrollAdapterRef = React.useRef();
    var callbackRef = React.useRef(callback);
    //    callbackRef.current = callback;
    React.useEffect(() => {
        var scrollAdapter = scrollAdapterRef.current = new ScrollEventAdapter();
        scrollAdapter.addEventListener("scrollbottom", () => {
            if (callbackRef.current) {
                callbackRef.current();
            }
        });
        return () => {
            scrollAdapterRef.current.dispose();
        };
    }, []);
    React.useEffect(() => {
        scrollAdapterRef.current.targetElement = targetElement;
        callbackRef.current = callback;
    }, [targetElement, callback]);
}
//# sourceMappingURL=use-on-scroll-bottom.js.map